import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { SurchargeType } from "../../../surcharge-type/surcharge-type.model";
import { SurchargeTypeRepository } from "../../../surcharge-type/surcharge-type.repository";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface SurchargeTypeChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-surcharge-type-select",
  templateUrl: "./surcharge-type-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class SurchargeTypeSelectComponent implements OnInit {
  private surchargeTypeRepository = inject(SurchargeTypeRepository);

  public readonly surchargeTypeChange = output<string>();
  @Input() public surchargeType: SurchargeType;
  public readonly disabled = input(false);
  public readonly required = input(false);

  public subscription = new Subscription();
  public surchargeTypeList: SelectItem[] = [];

  ngOnInit() {
    this.buildSurchargeTypeList();
  }

  public onSurchargeTypeChange(event: SurchargeTypeChangeEvent) {
    this.surchargeTypeChange.emit(event.value);
  }

  private buildSurchargeTypeList(): void {
    this.subscription.add(
      this.surchargeTypeRepository.list().subscribe((typeList) => {
        typeList.map((surchargeType) => {
          this.surchargeTypeList.push({
            label: surchargeType.getName(),
            title: surchargeType.getName() + " " + surchargeType.getId(),
            value: surchargeType,
          });
        });
      }),
    );
  }
}
